import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Colors from '../../theme/colors';
import Typography from '../../base/Typography';
import AssistiveText from '../../base/AssistiveText';
import Button from '../../base/Button';
import { Row, Col } from '../../base/Grid';
import './dynamic-callout.scss';

import {
  DynamicCalloutArticle,
  DynamicCalloutArticleFlag,
  DynamicCalloutArticleFlagTypography,
  DynamicCalloutCardContainer,
  DynamicCalloutCardImage,
  DynamicCalloutCardTypography,
  DynamicCalloutVisualLinkTypography,
  DynamicCalloutVisualLinkIcon,
  DynamicCalloutBannerImage,
} from './styles';

const buttonTextDefault = 'Get started';
const jsRedirect = (urlPath) => {
  window.location.href = (urlPath);
};

export const DynamicCalloutComponent = ({
  orientation,
  actionId,
  image,
  title,
  buttonText,
  url,
  tag,
  flag,
  visualLink,
  assistiveText,
}) => {
  // Adding appropriate color based on the flag prop. Primary is default.
  const flagPrimary = Colors.blueOnBlueHeadingAccess;
  const flagSecondary = Colors.cta.yellow;
  // If we add more colors, we will need to update this expression
  const flagColor = (flag === 'secondary')
    ? flagSecondary
    : flagPrimary;

  // card CTA orientation
  if (orientation === 'card') {
    return (
      <div className='dynamic-callout dynamic-callout--card'>
        <DynamicCalloutArticle className='nmxc-dynamic-callout-card-article'>
          <a
            className='dynamic-callout__article-container'
            href={url}
            id={actionId}
            data-tracking-id={actionId}
            >
            <AssistiveText
              text={assistiveText}
              component='p'
            />
            <DynamicCalloutArticleFlag flagColor={flagColor}>
              <DynamicCalloutArticleFlagTypography
                component='p'
                color={Colors.neutral.black}
                weight={500}
                disableBottomPadding>
                {tag}
              </DynamicCalloutArticleFlagTypography>
            </DynamicCalloutArticleFlag>
            <DynamicCalloutCardImage
              image={image}
              />
            <DynamicCalloutCardContainer className='nmxc-dynamic-callout-card-content-container'>
              <DynamicCalloutCardTypography
                component='h3'
                variant='h4'
                color={Colors.neutral.grey29}
                weight={500}
                hasLink={visualLink}>
                {title}
              </DynamicCalloutCardTypography>
              {!!visualLink
              && <DynamicCalloutVisualLinkTypography
                component='p'
                color={Colors.cta.blue}
                weight={500}
                disableBottomPadding>
                {visualLink}
                <DynamicCalloutVisualLinkIcon variant='arrow-right' />
              </DynamicCalloutVisualLinkTypography>}
            </DynamicCalloutCardContainer>
          </a>
        </DynamicCalloutArticle>
      </div>
    );
  }

  return (
    <div className='dynamic-callout dynamic-callout--banner'>
      <Row align='center'>
        <Col className='nmx-col-nested' xsmall={12} medium={3} large={3}>
          <DynamicCalloutBannerImage
            image={image}/>
        </Col>
        <Col xsmall={12} medium={5} large={6}>
          <div className='dynamic-callout__content-container'>
            <Typography
              component='h4'
              variant='h5'
              align='left'
              color={Colors.neutral.grey29}
              disableBottomPadding>
              {title}
            </Typography>
          </div>
        </Col>
        <Col xsmall={12} medium={4} large={3}>
          <div className='dynamic-callout__button-container'>
            <Button
              className='dynamic-callout__button'
              role='link'
              variant='tertiary'
              id={`${actionId}-button`}
              data-tracking-id={`${actionId}-button`}
              aria-label={assistiveText}
              onClick={(e) => {
                jsRedirect(url);
              }}>
              {buttonText || buttonTextDefault}
            </Button>
          </div>
        </Col>
      </Row>
      {/* Clickable overlay for the banner variation */}
      <button
        role='link'
      id={actionId}
        className='dynamic-callout__overlay'
        data-tracking-id={actionId}
        aria-label={assistiveText}
        onClick={(e) => {
          jsRedirect(url);
        }} />
    </div>
  );
};

DynamicCalloutComponent.propTypes = {
  orientation: PropTypes.string,
  actionId: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  url: PropTypes.string.isRequired,
  tag: PropTypes.string,
  flag: PropTypes.string,
  visualLink: PropTypes.string,
};

export default withTheme(DynamicCalloutComponent);
